import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Spinner,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

const Section = ({
  ticket,
  formatDate,
  handleCloseTicket,
  closeTicketLoading,
}) => {
  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <React.Fragment>
      <Col lg={12}>
        <Card className="mt-n4 mx-n4 mb-n5 shadow-sm border-0">
          <div className="bg-primary border-bottom text-white">
            <CardBody className="pb-4 mb-5">
              <Row>
                <div className="col-md">
                  <Row className="align-items-center">
                    <div className="col-md-auto">
                      <div className="avatar-md mb-md-0 mb-4">
                        <div className="avatar-title bg-white text-primary rounded-circle font-size-24 shadow">
                          <i className="ri-ticket-line fs-1"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md">
                      <h4 className="fw-bold text-white" id="ticket-title">
                        #{ticket.Id} - {ticket.Title}
                      </h4>
                      <div className="hstack gap-3 flex-wrap">
                        <div className="text-light fs-13">
                          <i className="ri-building-line align-bottom me-1 text-light"></i>
                          <span
                            id="ticket-client"
                            className="fw-medium text-light"
                          >
                            {ticket.UserName}
                          </span>
                        </div>
                        <div className="text-light fs-12">
                          <i className="ri-calendar-line align-bottom me-1"></i>
                          {formatDate(ticket.CreatedAt)}
                        </div>
                      </div>
                    </div>
                  </Row>
                </div>
                <div className="col-md-auto mt-md-0 mt-4">
                  <div className="hstack gap-2 flex-wrap">
                    {ticket.StatusText !== "Closed" && (
                      <Button
                        color="light"
                        className="btn-sm fw-medium"
                        onClick={toggle}
                      >
                        <i className="ri-check-double-line align-bottom me-1"></i>{" "}
                        Çözüldü İşaretle
                      </Button>
                    )}
                  </div>
                </div>
              </Row>
            </CardBody>
          </div>
        </Card>

        <Modal isOpen={modal} toggle={toggle} centered>
          <ModalHeader className="modal-title" toggle={toggle}></ModalHeader>

          <ModalBody className="py-3 px-5">
            <div className="mt-2 text-center">
              <i className="ri-check-double-line display-3 text-success"></i>
              <div className="mt-2 pt-2 fs-15">
                <h4>Talebi Çözüldü İşaretle</h4>
                <p className="text-muted mx-4 mb-0 fs-13">
                  Bu destek talebini çözüldü olarak kapatmak istediğinize emin
                  misiniz?
                </p>
              </div>
            </div>
            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
              <button
                type="button"
                className="btn w-sm btn-light"
                onClick={toggle}
                disabled={closeTicketLoading}
              >
                Kapat
              </button>
              <button
                type="button"
                className="btn w-sm btn-success"
                onClick={() => {
                  handleCloseTicket();
                }}
                disabled={closeTicketLoading}
              >
                {closeTicketLoading ? (
                  <>
                    <Spinner size="sm" className="me-1" /> İşleniyor...
                  </>
                ) : (
                  "Evet, Onayla!"
                )}
              </button>
            </div>
          </ModalBody>
        </Modal>
      </Col>
    </React.Fragment>
  );
};

export default Section;
